import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../../../Include/Header";
import Sidebar from "../../../Include/Sidebar";
import Breadcrumb from "../../../../../Components/Breadcrumb/Breadcrumb";
import Footer from "../../../Include/Footer";
import moment from "moment";
import { Pagination, Search } from "../../../Table";
import DropDown from "../../../../../Components/DropDown";
import { useDispatch, useSelector } from "react-redux";
import { getOneDeliveryChallan } from "../../../../../Store/prosafe/proTransaction/Challan/getOneDeliveryChallan";

const ReadOnlyInput = ({ label, value }) => (
    <div className="col-12 col-md-4 col-xl-4">
        <div className="input-block local-forms custom-select-wpr">
            <label>{label}</label>
            <input className="form-control" value={value || "-"} readOnly />
        </div>
    </div>
);

const ReadOnlyTextArea = ({ label, value }) => (
    <div className="col-12">
        <div className="input-block local-forms custom-select-wpr">
            <label>{label}</label>
            <textarea rows={3} style={{ resize: "none" }} className="form-control" value={value || "-"} readOnly />
        </div>
    </div>
);

const ViewDeliveryChallan = () => {
    const { state: data } = useLocation();
    const navigate = useNavigate();

    const dispatch = useDispatch();
    const [totalItems, setTotalItems] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [search, setSearch] = useState("");
    const [limit, setlimit] = useState(10);

    useEffect(() => {
        dispatch(getOneDeliveryChallan(data?._id))
    }, [dispatch])

    const challanData = useSelector((state) => state?.getOneDeliveryChallan?.user?.data)

    const [taxSummary, setTaxSummary] = useState({
        subtotal: 0,
        cgst: 0,
        sgst: 0,
        igst: 0,
        taxAmount: 0,
        roundOff: 0,
        total: 0,
        totalQty: 0
    });

    const taxType = useMemo(() => "igst", []);

    useEffect(() => {
        if (!challanData?.items_details) return;

        const subtotal = challanData.items_details.reduce(
            (sum, item) => sum + (parseFloat(item.amount) || 0),
            0
        );
        const totalQty = challanData.items_details.reduce(
            (sum, item) => sum + (parseFloat(item.qty) || 0),
            0
        );

        const taxRate = 0.18; // 18% tax
        const taxAmount = Number((subtotal * taxRate).toFixed(2));

        let cgst = 0,
            sgst = 0,
            igst = 0;

        if (taxType === "cgst_sgst") {
            cgst = Number((taxAmount / 2).toFixed(2));
            sgst = Number((taxAmount / 2).toFixed(2));
        } else {
            igst = taxAmount;
        }

        const totalBeforeRound = Number((subtotal + taxAmount).toFixed(2));
        const total = Math.round(totalBeforeRound);
        const roundOff = Number((total - totalBeforeRound).toFixed(2));

        setTaxSummary({
            subtotal,
            cgst,
            sgst,
            igst,
            taxAmount,
            roundOff,
            total,
            totalQty
        });
    }, [challanData, taxType]);

    const breadcrumbItems = [
        { label: "Dashboard", link: "/main-store/user/dashboard" },
        {
            label: "Delivery Challan",
            link: "/main-store/user/delivery-challan-management",
        },
        { label: "View Delivery Challan", active: true },
    ];

    const commentsData = useMemo(() => {
        let computed = challanData?.items_details || [];

        if (search) {
            computed = computed.filter((fi) =>
                fi.name?.toLowerCase().includes(search.toLowerCase())
            );
        }

        setTotalItems(computed.length);

        return computed.slice(
            (currentPage - 1) * limit,
            (currentPage - 1) * limit + limit
        );
    }, [currentPage, search, limit, challanData]);

    const totals = useMemo(() => {
        return commentsData?.reduce(
            (acc, item) => {
                acc.qty += parseFloat(item.qty) || 0;
                acc.weight += parseFloat(item.weight) || 0;
                acc.amount += parseFloat(item.amount) || 0;
                return acc;
            },
            {
                qty: 0,
                weight: 0,
                amount: 0,
            }
        );
    }, [commentsData]);

    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const handleOpen = () => setIsSidebarOpen(!isSidebarOpen);

    return (
        <div className={`main-wrapper ${isSidebarOpen ? "slide-nav" : ""}`}>
            <Header handleOpen={handleOpen} />
            <Sidebar />

            <div className="page-wrapper">
                <div className="content">
                    <Breadcrumb items={breadcrumbItems} />

                    {/* Basic Details */}
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="form-heading">
                                        <h4>View Delivery Challan Details</h4>
                                    </div>

                                    <div className="row">
                                        {/* <ReadOnlyInput
                                            label="Project No"
                                            value={challanData?.manual_project_no}
                                        /> */}

                                        <ReadOnlyInput
                                            label="Project"
                                            value={`${challanData?.projectDetails?.name} ${challanData?.projectDetails?.project_no
                                                ? `(${challanData?.projectDetails?.project_no})`
                                                : ""
                                                }`}
                                        />

                                        <ReadOnlyInput
                                            label="Party"
                                            value={challanData?.partyDetails?.name}
                                        />

                                        <ReadOnlyInput
                                            label="Challan No"
                                            value={challanData?.challan_no}
                                        />

                                        <ReadOnlyInput
                                            label="Date"
                                            value={moment(challanData?.date).format("YYYY-MM-DD")}
                                        />

                                        <ReadOnlyInput
                                            label="Challan Type"
                                            value={challanData?.challan_type || "Non-Returnable"}
                                        />

                                        {challanData?.purpose_of_dispatch && (
                                            <ReadOnlyInput
                                                label="Purpose of Dispatch"
                                                value={challanData?.purpose_of_dispatch}
                                            />
                                        )}

                                        {challanData?.challan_type === "Returnable" && (
                                            <>
                                                <ReadOnlyInput
                                                    label="Expected Return Date"
                                                    value={challanData?.expected_return_date ? moment(challanData.expected_return_date).format("YYYY-MM-DD") : "-"}
                                                />
                                                <ReadOnlyInput
                                                    label="Return Status"
                                                    value={challanData?.return_status || "Pending"}
                                                />
                                            </>
                                        )}

                                        <ReadOnlyTextArea
                                            label="Description"
                                            value={challanData?.description}
                                        />

                                    </div>

                                    <div className="row">
                                        <div className="form-heading">
                                            <h4 className="mb-4 ms-1">Bill To Details</h4>
                                        </div>

                                        <ReadOnlyInput
                                            label="Name"
                                            value={challanData?.bill_to?.name}
                                        />

                                        <ReadOnlyInput
                                            label="Email"
                                            value={challanData?.bill_to?.email}
                                        />

                                        <ReadOnlyInput
                                            label="Phone"
                                            value={challanData?.bill_to?.phone}
                                        />

                                        <ReadOnlyInput
                                            label="GST No"
                                            value={challanData?.bill_to?.gst_no}
                                        />

                                        <ReadOnlyInput
                                            label="Address"
                                            value={challanData?.bill_to?.address}
                                        />

                                        <ReadOnlyInput
                                            label="Address Two"
                                            value={challanData?.bill_to?.addressOne}
                                        />

                                        <ReadOnlyInput
                                            label="State"
                                            value={challanData?.bill_to?.state}
                                        />

                                        <ReadOnlyInput
                                            label="City"
                                            value={challanData?.bill_to?.city}
                                        />

                                        <ReadOnlyInput
                                            label="Pincode"
                                            value={challanData?.bill_to?.pincode}
                                        />
                                    </div>

                                    <div className="row">
                                        <div className="form-heading">
                                            <h4 className="mb-4 ms-1">Ship To Details</h4>
                                        </div>

                                        <ReadOnlyInput
                                            label="Name"
                                            value={challanData?.ship_to?.name}
                                        />

                                        <ReadOnlyInput
                                            label="Email"
                                            value={challanData?.ship_to?.email}
                                        />

                                        <ReadOnlyInput
                                            label="Phone"
                                            value={challanData?.ship_to?.phone}
                                        />

                                        <ReadOnlyInput
                                            label="GST No"
                                            value={challanData?.ship_to?.gst_no}
                                        />

                                        <ReadOnlyInput
                                            label="Address"
                                            value={challanData?.ship_to?.address}
                                        />

                                        <ReadOnlyInput
                                            label="Address Two"
                                            value={challanData?.ship_to?.addressOne}
                                        />

                                        <ReadOnlyInput
                                            label="State"
                                            value={challanData?.ship_to?.state}
                                        />

                                        <ReadOnlyInput
                                            label="City"
                                            value={challanData?.ship_to?.city}
                                        />

                                        <ReadOnlyInput
                                            label="Pincode"
                                            value={challanData?.ship_to?.pincode}
                                        />
                                    </div>

                                    <div className="row">
                                        <div className="form-heading">
                                            <h4 className="mb-4 ms-1"> Transportation Details</h4>
                                        </div>

                                        <ReadOnlyInput
                                            label="Date"
                                            value={moment(challanData?.transportation_details?.date).format("YYYY-MM-DD")}
                                        />

                                        <ReadOnlyInput
                                            label="Doc No"
                                            value={challanData?.transportation_details?.doc_no}
                                        />

                                        <ReadOnlyInput
                                            label="Delivery Terms"
                                            value={challanData?.transportation_details?.delivery_terms}
                                        />

                                        <ReadOnlyInput
                                            label="Dispatch Through"
                                            value={challanData?.transportation_details?.dispatch_through}
                                        />

                                        <ReadOnlyInput
                                            label="Other Ref"
                                            value={challanData?.transportation_details?.other_ref}
                                        />

                                    </div>

                                    <div className="row">
                                        <div className="form-heading">
                                            <h4 className="mb-4 ms-1"> Bank Details</h4>
                                        </div>

                                        <ReadOnlyInput
                                            label="GST"
                                            value={challanData?.bank_details?.gst_no || "24ASPPH9223F1ZP"}
                                        />

                                        <ReadOnlyInput
                                            label="Name"
                                            value={challanData?.bank_details?.name || "HDFC BANK"}
                                        />

                                        <ReadOnlyInput
                                            label="Account No"
                                            value={challanData?.bank_details?.account_no || "50200105734059"}
                                        />

                                        <ReadOnlyInput
                                            label="IFSC Code"
                                            value={challanData?.bank_details?.ifsc || "HDFC0004693"}
                                        />

                                        <ReadOnlyInput
                                            label="Account Holder Name"
                                            value={challanData?.bank_details?.acc_holder_name || "Vitthalesh Engineering Pvt. Ltd."}
                                        />
                                    </div>

                                    <div className="row">
                                        <div className="form-heading">
                                            <h4 className="mb-4 ms-1">Delivery By Details</h4>
                                        </div>

                                        <ReadOnlyInput
                                            label="Name"
                                            value={challanData?.delivery_by?.name}
                                        />

                                        <ReadOnlyInput
                                            label="Comment"
                                            value={challanData?.delivery_by?.comment}
                                        />

                                        <ReadOnlyInput
                                            label="Date"
                                            value={moment(challanData?.delivery_by?.date).format("YYYY-MM-DD")}
                                        />
                                    </div>


                                    <div className="row">
                                        <div className="form-heading">
                                            <h4 className="mb-4 ms-1">Receive By Details</h4>
                                        </div>

                                        <ReadOnlyInput
                                            label="Name"
                                            value={challanData?.received_by?.name}
                                        />

                                        <ReadOnlyInput
                                            label="Comment"
                                            value={challanData?.received_by?.comment}
                                        />

                                        <ReadOnlyInput
                                            label="Date"
                                            value={moment(challanData?.received_by?.date).format("YYYY-MM-DD")}
                                        />
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Items Table */}
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="page-table-header mb-2 p-0">
                                        <div className="row align-items-center">
                                            <div className="col">
                                                <div className="doctor-table-blk">
                                                    <h3>Items List</h3>
                                                    <div className="doctor-search-blk">
                                                        <div className="top-nav-search table-search-blk">
                                                            <form>
                                                                <Search
                                                                    onSearch={(value) => {
                                                                        setSearch(value);
                                                                        setCurrentPage(1);
                                                                    }}
                                                                />
                                                                {/* eslint-disable jsx-a11y/anchor-is-valid */}
                                                                <a className="btn">
                                                                    <img
                                                                        src="/assets/img/icons/search-normal.svg"
                                                                        alt="search"
                                                                    />
                                                                </a>
                                                            </form>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="pageDropDown col-auto text-end float-end ms-auto download-grp">
                                                <DropDown
                                                    limit={limit}
                                                    onLimitChange={(val) => setlimit(val)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table border-0 custom-table comman-table mb-0">
                                            <thead>
                                                <tr>
                                                    <th>Sr.</th>
                                                    <th>Name.</th>
                                                    <th>HSN</th>
                                                    <th>Qty</th>
                                                    <th>Unit</th>
                                                    <th>Weight</th>
                                                    {challanData?.challan_type !== "Returnable" && (
                                                        <>
                                                            <th>Rate</th>
                                                            <th>Amount</th>
                                                        </>
                                                    )}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {commentsData?.map((item, index) => (
                                                    <tr key={item._id || index}>
                                                        <td>{index + 1}</td>
                                                        <td>{item.name || "-"}</td>
                                                        <td>{item.hsn || "-"}</td>
                                                        <td>{item.qty || "-"}</td>
                                                        <td>{item?.unit?.name || "-"}</td>
                                                        <td>{item.weight || "-"}</td>
                                                        {challanData?.challan_type !== "Returnable" && (
                                                            <>
                                                                <td>{item.rate || "-"}</td>
                                                                <td>{item.amount || "-"}</td>
                                                            </>
                                                        )}
                                                    </tr>
                                                ))}
                                                {commentsData?.length > 0 && (
                                                    <tr style={{ fontWeight: 'bold', backgroundColor: '#f8f9fa' }}>
                                                        <td colSpan="2" className="text-left" style={{ padding: "0 100px" }}>Total</td>
                                                        <td>-</td>
                                                        <td>{totals.qty}</td>
                                                        <td>-</td>
                                                        <td>{totals.weight}</td>
                                                        {challanData?.challan_type !== "Returnable" && (
                                                            <>
                                                                <td>-</td>
                                                                <td>{totals.amount.toFixed(2)}</td>
                                                            </>
                                                        )}
                                                    </tr>
                                                )}
                                                {commentsData?.length === 0 ? (
                                                    <tr>
                                                        <td colSpan="999">
                                                            <div className="no-table-data">
                                                                No Data Found!
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ) : null}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="row align-center mt-3 mb-2">
                                        <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6">
                                            <div
                                                className="dataTables_info"
                                                id="DataTables_Table_0_info"
                                                role="status"
                                                aria-live="polite"
                                            >
                                                Showing {Math.min(limit, totalItems)} from {totalItems}{" "}
                                                data
                                            </div>
                                        </div>
                                        <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6 ">
                                            <div
                                                className="dataTables_paginate paging_simple_numbers"
                                                id="DataTables_Table_0_paginate"
                                            >
                                                <Pagination
                                                    total={totalItems}
                                                    itemsPerPage={limit}
                                                    currentPage={currentPage}
                                                    onPageChange={(page) => setCurrentPage(page)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Terms & Tax Summary Section */}
                    <div className="row mb-3 mt-4">
                        <div className="col-12 col-md-7 col-xl-8">
                            <div
                                className="card shadow-sm h-100"
                                style={{ border: "1px solid #e0e0e0" }}
                            >
                                <div
                                    className="card-header"
                                    style={{
                                        backgroundColor: "rgba(255, 105, 35, 0.1)",
                                        border: "1px solid var(--primary-clr)",
                                        color: "var(--primary-clr)",
                                    }}
                                >
                                    <h6
                                        className="mb-0 fw-semibold"
                                        style={{ color: "var(--primary-clr)", fontSize: "15px" }}
                                    >
                                        <i
                                            className="fa fa-file-text me-2"
                                            style={{ color: "var(--primary-clr)" }}
                                        ></i>
                                        Terms and Conditions
                                    </h6>
                                </div>

                                <div
                                    className="card-body"
                                    style={{
                                        height: "400px",
                                        overflowY: "auto",
                                        border: "1px solid var(--primary-clr)",
                                        borderTop: 0,
                                        fontSize: "14px",
                                        padding: "20px"
                                    }}
                                >
                                    {challanData?.terms_and_cond ? (
                                        <div
                                            dangerouslySetInnerHTML={{
                                                __html: challanData.terms_and_cond,
                                            }}
                                        />
                                    ) : (
                                        <p>No terms added</p>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-md-5 col-xl-4">
                            {challanData?.challan_type === "Returnable" ? (
                                <div
                                    className="card shadow-sm h-100"
                                    style={{ border: "1px solid #e0e0e0" }}
                                >
                                    <div
                                        className="card-header"
                                        style={{
                                            background: "linear-gradient(135deg, #17a2b8 0%, #138496 100%)",
                                            color: "white",
                                            padding: "14px 20px",
                                            borderRadius: "0.25rem 0.25rem 0 0",
                                        }}
                                    >
                                        <h6
                                            className="mb-0 fw-semibold"
                                            style={{
                                                fontSize: "15px",
                                                color: "#fff",
                                                letterSpacing: "0.3px",
                                            }}
                                        >
                                            <i className="fa fa-refresh me-2"></i>
                                            Returnable Information
                                        </h6>
                                    </div>
                                    <div className="card-body" style={{ padding: "20px" }}>
                                        <div className="mb-3 pb-3" style={{ borderBottom: "1px solid #e9ecef" }}>
                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                <span style={{ color: "#6c757d", fontSize: "14px" }}>Type</span>
                                                <span className="badge bg-info" style={{ fontSize: "13px" }}>Returnable</span>
                                            </div>
                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                <span style={{ color: "#6c757d", fontSize: "14px" }}>Total Quantity</span>
                                                <span className="fw-semibold" style={{ color: "#2c3e50", fontSize: "15px" }}>
                                                    {taxSummary.totalQty.toFixed(2)}
                                                </span>
                                            </div>
                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                <span style={{ color: "#6c757d", fontSize: "14px" }}>Return Status</span>
                                                <span className={`badge ${challanData?.return_status === 'Returned' ? 'bg-success' : 'bg-warning'}`} style={{ fontSize: "13px" }}>
                                                    {challanData?.return_status || "Pending"}
                                                </span>
                                            </div>
                                            <div className="d-flex justify-content-between align-items-center">
                                                <span style={{ color: "#6c757d", fontSize: "14px" }}>Expected Return</span>
                                                <span className="fw-semibold" style={{ color: "#2c3e50", fontSize: "14px" }}>
                                                    {challanData?.expected_return_date ? moment(challanData.expected_return_date).format("YYYY-MM-DD") : "N/A"}
                                                </span>
                                            </div>
                                        </div>
                                        <div
                                            className="p-3 rounded text-center"
                                            style={{
                                                backgroundColor: "rgba(23, 162, 184, 0.1)",
                                                border: "1px dashed #17a2b8",
                                                color: "#117a8b",
                                                fontSize: "12px",
                                                fontWeight: "500",
                                            }}
                                        >
                                            <i className="fa fa-info-circle me-1"></i>
                                            Rate & Financial details are hidden for Returnable Delivery Challan.
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div
                                    className="card shadow-sm h-100"
                                    style={{ border: "1px solid #e0e0e0" }}
                                >
                                    <div
                                        className="card-header"
                                        style={{
                                            background: "linear-gradient(135deg, var(--primary-clr) 0%, #ff8c42 100%)",
                                            color: "white",
                                            padding: "14px 20px",
                                            borderRadius: "0.25rem 0.25rem 0 0",
                                        }}
                                    >
                                        <h6
                                            className="mb-0 fw-semibold"
                                            style={{
                                                fontSize: "15px",
                                                color: "#fff",
                                                letterSpacing: "0.3px",
                                            }}
                                        >
                                            <i className="fa fa-calculator me-2"></i>
                                            Tax Summary
                                        </h6>
                                    </div>
                                    <div className="card-body" style={{ padding: "20px" }}>
                                        <div
                                            className="mb-3 pb-3"
                                            style={{ borderBottom: "1px solid #e9ecef" }}
                                        >
                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                <span style={{ color: "#6c757d", fontSize: "14px" }}>
                                                    Subtotal
                                                </span>
                                                <span
                                                    className="fw-semibold"
                                                    style={{ color: "#2c3e50", fontSize: "15px" }}
                                                >
                                                    ₹ {taxSummary.subtotal.toFixed(2)}
                                                </span>
                                            </div>
                                            <div className="d-flex justify-content-between align-items-center">
                                                <span style={{ color: "#6c757d", fontSize: "14px" }}>
                                                    Total Quantity
                                                </span>
                                                <span
                                                    className="fw-semibold"
                                                    style={{ color: "#2c3e50", fontSize: "15px" }}
                                                >
                                                    {taxSummary.totalQty.toFixed(2)}
                                                </span>
                                            </div>
                                        </div>

                                        <div
                                            className="mb-3 pb-3"
                                            style={{ borderBottom: "1px solid #e9ecef" }}
                                        >
                                            <div className="mb-2">
                                                <span
                                                    className="fw-semibold"
                                                    style={{ color: "var(--primary-clr)", fontSize: "14px" }}
                                                >
                                                    Tax Breakdown (18%)
                                                </span>
                                            </div>
                                            {taxType === "cgst_sgst" ? (
                                                <>
                                                    <div className="d-flex justify-content-between align-items-center mb-2 ms-1">
                                                        <span style={{ color: "#6c757d", fontSize: "13px" }}>
                                                            CGST @ 9%
                                                        </span>
                                                        <span style={{ color: "#2c3e50", fontSize: "14px" }}>
                                                            ₹ {taxSummary.cgst.toFixed(2)}
                                                        </span>
                                                    </div>
                                                    <div className="d-flex justify-content-between align-items-center ms-1">
                                                        <span style={{ color: "#6c757d", fontSize: "13px" }}>
                                                            SGST @ 9%
                                                        </span>
                                                        <span style={{ color: "#2c3e50", fontSize: "14px" }}>
                                                            ₹ {taxSummary.sgst.toFixed(2)}
                                                        </span>
                                                    </div>
                                                </>
                                            ) : (
                                                <div className="d-flex justify-content-between align-items-center ms-1">
                                                    <span style={{ color: "#6c757d", fontSize: "13px" }}>
                                                        IGST @ 18%
                                                    </span>
                                                    <span style={{ color: "#2c3e50", fontSize: "14px" }}>
                                                        ₹ {taxSummary.igst.toFixed(2)}
                                                    </span>
                                                </div>
                                            )}
                                        </div>

                                        <div
                                            className="mb-3 pb-3"
                                            style={{ borderBottom: "1px solid #e9ecef" }}
                                        >
                                            <div className="d-flex justify-content-between align-items-center">
                                                <span style={{ color: "#6c757d", fontSize: "14px" }}>
                                                    Round Off
                                                </span>
                                                <span style={{ color: "#2c3e50", fontSize: "14px" }}>
                                                    {taxSummary.roundOff > 0 ? "+ " : taxSummary.roundOff < 0 ? "- " : ""} ₹{" "}
                                                    {Math.abs(taxSummary.roundOff).toFixed(2)}
                                                </span>
                                            </div>
                                        </div>

                                        <div
                                            className="p-3 rounded"
                                            style={{
                                                background:
                                                    "linear-gradient(135deg, rgba(255, 105, 35, 0.1) 0%, rgba(255, 140, 66, 0.1) 100%)",
                                                border: "1px solid var(--primary-clr)",
                                            }}
                                        >
                                            <div className="d-flex justify-content-between align-items-center">
                                                <span
                                                    className="fw-bold"
                                                    style={{ color: "var(--primary-clr)", fontSize: "16px" }}
                                                >
                                                    Total Amount
                                                </span>
                                                <span
                                                    className="fw-bold"
                                                    style={{ color: "var(--primary-clr)", fontSize: "18px" }}
                                                >
                                                    ₹ {taxSummary.total.toFixed(2)}
                                                </span>
                                            </div>
                                        </div>

                                        <div
                                            className="mt-3 p-2 rounded text-center"
                                            style={{
                                                backgroundColor: "#f8f9fa",
                                                border: "1px dashed var(--primary-clr)",
                                            }}
                                        >
                                            <small
                                                style={{
                                                    color: "var(--primary-clr)",
                                                    fontSize: "12px",
                                                    fontWeight: "500",
                                                }}
                                            >
                                                <i className="fa fa-info-circle me-1"></i>
                                                Tax Type: {taxType === "cgst_sgst" ? "CGST + SGST" : "IGST"}
                                            </small>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Back Button */}
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="col-12 text-end">
                                        <div className="doctor-submit text-end">
                                            <button
                                                type="button"
                                                className="btn btn-primary submit-form me-2"
                                                onClick={() =>
                                                    navigate("/main-store/user/delivery-challan-management")
                                                }
                                            >
                                                Back
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Footer />
            </div>
        </div>
    );
};

export default ViewDeliveryChallan;
